<template lang="pug">
    filter-mobile
        form.c-form.inverse

            // Sort by Full Name
            v-select(
                name="createdAt"
                append-icon="expand_more"
                outline
                v-model="model.sort.name"
                @change="e => sortHandler('createdAt', e)"
                :items="$t('selection.sort')"
                :label="$t('business.mobile.sort.date')"
            )

            // Filter by Status
            v-select(
                name="status"
                append-icon="expand_more"
                outline
                @change="e => filterHandler({ name: 'isActive', value: e})"
                :items="$t('business.mobile.filter.status.filter')"
                :label="$t('business.mobile.filter.status.name')"
            )
</template>

<script>
    import VueTypes from 'vue-types';
    import FilterMobile from '~components/FilterMobile';

    export default {
        components: {
            FilterMobile
        },
        data() {
            return {
                model: {
                    sort: {
                        name: null,
                        email: null
                    }
                }
            };
        },
        watch: {
            ['model.sort.name'](val) {
                if (val !== null && this.model.sort.email !== null) {
                    this.model.sort.email = null;
                }
            },
            ['model.sort.email'](val) {
                if (val !== null && this.model.sort.name !== null) {
                    this.model.sort.name = null;
                }
            }
        },
        props: {
            sortHandler: VueTypes.func.def(() => {}),
            filterHandler: VueTypes.func.def(() => {})
        }
    };
</script>
